export enum Locale {
  Da = "da",
  De = "de",
  En = "en",
  Es = "es",
  Fr = "fr",
  Hi = "hi",
  It = "it",
  Nl = "nl",
  Pl = "pl",
  Pt = "pt",
  Ro = "ro",
  Sv = "sv",
  Tr = "tr",
  Zh = "zh",
}
